//
//
//
//
//
//
//
//
//

export default {
    name: "other2",
    created() {
        document.title = this.$t('other.other2')[0]
    }
}



// WEBPACK FOOTER //
// ./src/page/other/other2.vue